export default __webpack_public_path__ + "static/media/vect-eclipse-success.66c5e881.svg";